import React, { Fragment } from 'react';

const LinkedInTracking = () => {
  return (
    <Fragment>
      <script
        dangerouslySetInnerHTML={{
          __html: `
          _linkedin_partner_id = "5493082";
          window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
          window._linkedin_data_partner_ids.push(_linkedin_partner_id);
    `,
        }}
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `
          (function(l) {
            if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
            window.lintrk.q=[]}
            var s = document.getElementsByTagName("script")[0];
            var b = document.createElement("script");
            b.type = "text/javascript";b.async = true;
            b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
            s.parentNode.insertBefore(b, s);})(window.lintrk);
    `,
        }}
      />
      <noscript>
        <img
          height="1"
          style={{ display: 'none' }}
          width="1"
          alt=""
          src="https://px.ads.linkedin.com/collect/?pid=5493082&fmt=gif"
        />
      </noscript>
    </Fragment>
  );
};

export default LinkedInTracking;

export const InsertLinkedingTracking = {
  init: function () {
    if (typeof window === 'undefined') return;

    this.addLinkedInTrackingScripts();
    this.addLinkedInNoScript();
  },

  addLinkedInTrackingScripts: function () {
    const partnerIdScript = document.createElement('script');
    partnerIdScript.text = `
      _linkedin_partner_id = "5493082";
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);
    `;
    document.head.appendChild(partnerIdScript);

    const insightScript = document.createElement('script');
    insightScript.text = `
      (function(l) {
        if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
        window.lintrk.q=[]}
        var s = document.getElementsByTagName("script")[0];
        var b = document.createElement("script");
        b.type = "text/javascript";b.async = true;
        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
        s.parentNode.insertBefore(b, s);})(window.lintrk);
    `;
    document.head.appendChild(insightScript);
  },

  addLinkedInNoScript: function () {
    const noScriptContainer = document.createElement('noscript');
    const imgElement = document.createElement('img');
    imgElement.height = '1';
    imgElement.width = '1';
    imgElement.alt = '';
    imgElement.src = 'https://px.ads.linkedin.com/collect/?pid=5493082&fmt=gif';
    imgElement.style.display = 'none';

    noScriptContainer.appendChild(imgElement);
    document.head.appendChild(noScriptContainer);
  },
};
